import { Link } from "react-router-dom";
import { Sparkles, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

// Skills upload to the Claude apps (claude.ai web + Claude Desktop) as a folder-at-root .zip —
// exactly what build_skill_zip already emits (slug/SKILL.md). So this is just framing + the
// 3-step path; onDownload is the same download the "Download .zip" button uses. All content is
// static JSX text (no HTML render) — the stored-XSS invariant is untouched.
export function UseInClaudeApps({ onDownload, className = "" }) {
  const step = "flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[color:var(--rb-surface)] text-[10px] font-semibold text-[color:var(--rb-accent)]";
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" data-testid="use-in-claude-apps"
          className={`rounded-xl border-[color:var(--rb-border)] text-[color:var(--rb-text)] hover:border-[color:var(--rb-border-strong)] hover:bg-[color:var(--rb-surface)] ${className}`}>
          <Sparkles className="mr-2 h-4 w-4 text-[color:var(--rb-accent)]" /> Use in Claude apps
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 border-[color:var(--rb-border)] bg-[color:var(--rb-obsidian)] text-[color:var(--rb-text)]">
        <div className="rb-display text-sm font-semibold">Use in Claude.ai or Claude Desktop</div>
        <ol className="mt-3 space-y-3 text-sm text-[color:var(--rb-text-dim)]">
          <li className="flex items-start gap-2.5">
            <span className={step}>1</span>
            <div>
              Download the skill.
              <Button onClick={onDownload} size="sm" data-testid="use-in-claude-download"
                className="mt-2 h-8 rounded-lg bg-[color:var(--rb-accent)] text-[color:var(--rb-void)] hover:bg-[color:var(--rb-accent-2)]">
                <Download className="mr-1.5 h-3.5 w-3.5" /> Download .zip
              </Button>
            </div>
          </li>
          <li className="flex items-start gap-2.5">
            <span className={step}>2</span>
            <div>In Claude, open <b className="text-[color:var(--rb-text)]">Customize &rarr; Skills &rarr; +</b> and upload the <span className="rb-mono">.zip</span>.</div>
          </li>
          <li className="flex items-start gap-2.5">
            <span className={step}>3</span>
            <div>Toggle it on. Same steps on web and desktop.</div>
          </li>
        </ol>
        <Link to="/use-with-claude" className="mt-3 inline-block text-xs text-[color:var(--rb-accent)] hover:underline">Full guide &rarr;</Link>
      </PopoverContent>
    </Popover>
  );
}
